// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3gUYm","colCheckbox":"styles_colCheckbox__2QqYQ"};